import React, { Component } from 'react';
import { scaleBand } from 'd3';
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css = ".matrix {\n  overflow: auto;\n  height: 100%;\n}\n";
styleInject(css);
var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var SCROLLBAR_SIZE = 17;
var Matrix = function (_Component) {
  inherits(Matrix, _Component);
  function Matrix(props) {
    classCallCheck(this, Matrix);
    var _this = possibleConstructorReturn(this, (Matrix.__proto__ || Object.getPrototypeOf(Matrix)).call(this, props));
    _this.resize = function () {
      if (_this.matrix.current) {
        _this.setState({
          width: _this.matrix.current.clientWidth //responsive chart width
        });
      }
    };
    _this.mouseover = function (e, rowIndex, colIndex) {
      _this.setState({
        mouseoverRowIndex: rowIndex,
        mouseoverColIndex: colIndex
      });
      _this.props.onMouseOverHandler(e, rowIndex, colIndex);
    };
    _this.mouseout = function (e) {
      _this.setState({
        mouseoverRowIndex: -1,
        mouseoverColIndex: -1
      });
      _this.props.onMouseOutHandler(e);
    };
    _this.state = {
      width: 500,
      mouseoverRowIndex: -1,
      mouseoverColIndex: -1
    };
    _this.matrix = React.createRef();
    _this.ctx = document.createElement('canvas').getContext("2d");
    return _this;
  }
  createClass(Matrix, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.resize); //add resize listener for responsiveness

      this.resize(); //initial resize
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resize);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      var _props = this.props,
        data = _props.data,
        rows = _props.rows,
        columns = _props.columns,
        orders = _props.orders,
        orderBy = _props.orderBy,
        colorFunction = _props.colorFunction,
        height = _props.height,
        font = _props.font,
        formatColHeading = _props.formatColHeading,
        formatRowHeading = _props.formatRowHeading,
        gridLinesColor = _props.gridLinesColor,
        linesHighlightedWidth = _props.linesHighlightedWidth,
        linesNotHighlightedWidth = _props.linesNotHighlightedWidth,
        minRectSize = _props.minRectSize,
        normalOpacity = _props.normalOpacity,
        notHighlightedOpacity = _props.notHighlightedOpacity,
        onClickHandler = _props.onClickHandler,
        textOffset = _props.textOffset,
        transition = _props.transition;
      this.ctx.font = font;

      //get text label lengths
      var horizontalTextSize = getTextSize(this.ctx, rows, formatRowHeading, textOffset);
      var verticalTextSize = getTextSize(this.ctx, columns, formatColHeading, textOffset);
      var minHeight = verticalTextSize + rows.length * minRectSize;
      var effectiveHeight = Math.max(minHeight, height);
      var gridHeight = effectiveHeight - verticalTextSize - 10;
      var tooTall = minHeight > height;
      var minWidth = horizontalTextSize + columns.length * minRectSize + (tooTall ? SCROLLBAR_SIZE : 0);
      var effectiveWidth = Math.max(minWidth, this.state.width);
      var gridWidth = effectiveWidth - horizontalTextSize - (tooTall ? SCROLLBAR_SIZE : 0);

      //in svg, y is rows and x is columns
      var x = scaleBand().range([0, gridWidth]).domain(orders.columns[orderBy]);
      var y = scaleBand().range([0, gridHeight]).domain(orders.rows[orderBy]);
      var rectWidth = x.bandwidth();
      var rectHeight = y.bandwidth();
      return React.createElement('div', {
        className: 'matrix',
        ref: this.matrix,
        onMouseLeave: this.mouseout,
        style: {
          font: this.props.font
        }
      }, React.createElement('svg', {
        width: effectiveWidth,
        height: verticalTextSize
      }, React.createElement('g', {
        transform: 'translate(' + horizontalTextSize + ', ' + verticalTextSize + ')'
      }, columns.map(function (d, i) {
        return React.createElement(ColHeading, {
          key: i,
          data: d,
          defaultHighlight: _this2.props.defaultHighlight,
          font: font,
          formatColHeading: formatColHeading,
          index: i,
          normalOpacity: normalOpacity,
          notHighlightedOpacity: notHighlightedOpacity,
          rectWidth: rectWidth,
          textOffset: textOffset,
          transition: transition,
          verticalTextSize: verticalTextSize,
          xScale: x,
          mouseover: _this2.mouseover,
          mouseoverColIndex: _this2.state.mouseoverColIndex,
          mouseoverRowIndex: _this2.state.mouseoverRowIndex,
          onClickHandler: onClickHandler
        });
      }))), React.createElement('div', {
        style: height < effectiveHeight ? {
          "maxHeight": height,
          "overflowY": "auto",
          "width": effectiveWidth
        } : {}
      }, React.createElement('svg', {
        width: effectiveWidth - (tooTall ? SCROLLBAR_SIZE : 0),
        height: gridHeight
      }, React.createElement('g', {
        transform: 'translate(' + horizontalTextSize + ')'
      }, data.map(function (d, i) {
        return React.createElement(Row, {
          key: i,
          data: d,
          chartWidth: gridWidth,
          colorFunction: colorFunction,
          columns: columns,
          defaultHighlight: _this2.props.defaultHighlight,
          font: font,
          formatRowHeading: formatRowHeading,
          gridLinesColor: gridLinesColor,
          heading: rows[i],
          horizontalTextSize: horizontalTextSize,
          index: i,
          linesHighlightedWidth: linesHighlightedWidth,
          linesNotHighlightedWidth: linesNotHighlightedWidth,
          normalOpacity: normalOpacity,
          notHighlightedOpacity: notHighlightedOpacity,
          rectHeight: rectHeight,
          rectWidth: rectWidth,
          textOffset: textOffset,
          transition: transition,
          xScale: x,
          yScale: y,
          mouseover: _this2.mouseover,
          mouseoverColIndex: _this2.state.mouseoverColIndex,
          mouseoverRowIndex: _this2.state.mouseoverRowIndex,
          onClickHandler: onClickHandler
        });
      }), this.props.columns.map(function (d, i) {
        return React.createElement(ColGrid, {
          key: i,
          chartHeight: gridHeight,
          data: d,
          index: i,
          gridLinesColor: gridLinesColor,
          linesHighlightedWidth: linesHighlightedWidth,
          linesNotHighlightedWidth: linesNotHighlightedWidth,
          rectWidth: rectWidth,
          xScale: x,
          mouseoverColIndex: _this2.state.mouseoverColIndex
        });
      })))));
    }
  }]);
  return Matrix;
}(Component);
Matrix.defaultProps = {
  height: 500,
  defaultHighlight: true,
  font: "16px Arial",
  formatColHeading: function formatColHeading(text, count) {
    return [text, count > 0 ? "(" + count + ")" : ""];
  },
  formatRowHeading: function formatRowHeading(text, count) {
    return [text, count > 0 ? "(" + count + ")" : ""];
  },
  gridLinesColor: "gray",
  linesHighlightedWidth: 3,
  linesNotHighlightedWidth: 1,
  minRectSize: 20,
  normalOpacity: 1,
  notHighlightedOpacity: 0.25,
  onClickHandler: function onClickHandler(e, rowIndex, colIndex) {},
  onMouseOutHandler: function onMouseOutHandler(e) {},
  onMouseOverHandler: function onMouseOverHandler(e, rowIndex, colIndex) {},
  textOffset: 5,
  transition: "1s"
};
var Row = function (_Component2) {
  inherits(Row, _Component2);
  function Row(props) {
    classCallCheck(this, Row);
    return possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).call(this, props));
  }
  createClass(Row, [{
    key: 'render',
    value: function render() {
      var _this4 = this;
      var formattedHeading = this.props.formatRowHeading(this.props.heading.name, this.props.heading.count);
      var fullName = this.props.heading.name + " " + formattedHeading[1];
      var rowIsFullOpacity = this.props.index === this.props.mouseoverRowIndex || this.props.mouseoverRowIndex === -1 && this.props.mouseoverColIndex === -1 && this.props.defaultHighlight;
      var rowIsHightlighted = this.props.index === this.props.mouseoverRowIndex;
      return React.createElement('g', {
        style: {
          fontWeight: this.props.index === this.props.mouseoverRowIndex ? "bold" : "normal",
          transform: "translateY(" + this.props.yScale(this.props.index) + "px)",
          transition: this.props.transition,
          transitionProperty: "transform"
        }
      }, this.props.data.map(function (d, i) {
        return React.createElement('rect', {
          key: i,
          fill: _this4.props.colorFunction(d.z),
          x: _this4.props.xScale(d.c),
          y: 0,
          width: _this4.props.rectWidth,
          height: _this4.props.rectHeight,
          onMouseOver: function onMouseOver(e) {
            return _this4.props.mouseover(e, _this4.props.index, i);
          },
          onClick: function onClick(e) {
            return _this4.props.onClickHandler(e, _this4.props.index, i);
          },
          style: {
            opacity: rowIsFullOpacity || i === _this4.props.mouseoverColIndex ? _this4.props.normalOpacity : _this4.props.notHighlightedOpacity,
            transition: _this4.props.transition,
            transitionProperty: "x"
          }
        }, React.createElement('title', null, _this4.props.heading.name + ", " + _this4.props.columns[i].name + ": " + d.z));
      }), React.createElement('line', {
        x2: this.props.chartWidth,
        stroke: this.props.gridLinesColor,
        strokeWidth: rowIsHightlighted ? this.props.linesHighlightedWidth : this.props.linesNotHighlightedWidth
      }), React.createElement('line', {
        x2: this.props.chartWidth,
        y1: this.props.rectHeight,
        y2: this.props.rectHeight,
        stroke: this.props.gridLinesColor,
        strokeWidth: rowIsHightlighted ? this.props.linesHighlightedWidth : this.props.linesNotHighlightedWidth
      }), React.createElement('g', {
        onMouseOver: function onMouseOver(e) {
          return _this4.props.mouseover(e, _this4.props.index, -1);
        },
        onClick: function onClick(e) {
          return _this4.props.onClickHandler(e, _this4.props.index, -1);
        },
        opacity: rowIsFullOpacity ? this.props.normalOpacity : this.props.notHighlightedOpacity,
        transform: "translate(-" + this.props.textOffset + "," + this.props.rectHeight / 2 + ")"
      }, React.createElement('text', {
        x: 10 - this.props.horizontalTextSize,
        y: 0,
        dy: '0.35em',
        textAnchor: 'start'
      }, React.createElement('title', null, fullName), formattedHeading[0]), React.createElement('text', {
        x: 0,
        y: 0,
        dy: '0.35em',
        textAnchor: 'end'
      }, React.createElement('title', null, fullName), formattedHeading[1])));
    }
  }]);
  return Row;
}(Component);
var ColGrid = function (_Component3) {
  inherits(ColGrid, _Component3);
  function ColGrid() {
    classCallCheck(this, ColGrid);
    return possibleConstructorReturn(this, (ColGrid.__proto__ || Object.getPrototypeOf(ColGrid)).apply(this, arguments));
  }
  createClass(ColGrid, [{
    key: 'render',
    value: function render() {
      var colIsHighlighted = this.props.index === this.props.mouseoverColIndex;
      return React.createElement('g', {
        transform: "translate(" + this.props.xScale(this.props.index) + ") rotate(-90)"
      }, React.createElement('line', {
        x1: -1 * this.props.chartHeight,
        stroke: this.props.gridLinesColor,
        strokeWidth: colIsHighlighted ? this.props.linesHighlightedWidth : this.props.linesNotHighlightedWidth
      }), React.createElement('line', {
        x1: -1 * this.props.chartHeight,
        y1: this.props.rectWidth,
        y2: this.props.rectWidth,
        stroke: this.props.gridLinesColor,
        strokeWidth: colIsHighlighted ? this.props.linesHighlightedWidth : this.props.linesNotHighlightedWidth
      }));
    }
  }]);
  return ColGrid;
}(Component);
var ColHeading = function (_Component4) {
  inherits(ColHeading, _Component4);
  function ColHeading() {
    classCallCheck(this, ColHeading);
    return possibleConstructorReturn(this, (ColHeading.__proto__ || Object.getPrototypeOf(ColHeading)).apply(this, arguments));
  }
  createClass(ColHeading, [{
    key: 'render',
    value: function render() {
      var _this7 = this;
      var formattedHeading = this.props.formatColHeading(this.props.data.name, this.props.data.count);
      var fullName = this.props.data.name + " " + formattedHeading[1];
      return React.createElement('g', {
        onMouseOver: function onMouseOver(e) {
          return _this7.props.mouseover(e, -1, _this7.props.index);
        },
        onClick: function onClick(e) {
          return _this7.props.onClickHandler(e, -1, _this7.props.index);
        },
        style: {
          opacity: this.props.index === this.props.mouseoverColIndex || this.props.mouseoverRowIndex === -1 && this.props.mouseoverColIndex === -1 && this.props.defaultHighlight ? this.props.normalOpacity : this.props.notHighlightedOpacity,
          fontWeight: this.props.index === this.props.mouseoverColIndex ? "bold" : "normal",
          transform: "translateX(" + this.props.xScale(this.props.index) + "px) rotate(-90deg)",
          transition: this.props.transition,
          transitionProperty: "transform"
        }
      }, React.createElement('text', {
        x: this.props.textOffset,
        y: this.props.rectWidth / 2,
        dy: '0.32em',
        textAnchor: 'start'
      }, React.createElement('title', null, fullName), formattedHeading[0]), React.createElement('text', {
        x: this.props.textOffset + this.props.verticalTextSize - 10,
        y: this.props.rectWidth / 2,
        dy: '0.32em',
        textAnchor: 'end'
      }, React.createElement('title', null, fullName), formattedHeading[1]));
    }
  }]);
  return ColHeading;
}(Component);

//given a canvas context and some text, return the longest length in pixels

function getTextSize(ctx, headings, formatText, textOffset) {
  var longestLength = 0;
  for (var i = 0; i < headings.length; ++i) {
    var length = ctx.measureText(formatText(headings[i].name, headings[i].count).join(" ")).width;
    if (length > longestLength) {
      longestLength = length;
    }
  }
  return longestLength + textOffset;
}
export default Matrix;